<svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M20.5975 13.1748C20.6475 12.7998 20.6725 12.4123 20.6725 11.9998C20.6725 11.5998 20.6475 11.1998 
    20.585 10.8248L23.1225 8.84976C23.3475 8.67476 23.41 8.33726 23.2725 8.08726L20.8725 3.93726C20.7225 
    3.66226 20.41 3.57476 20.135 3.66226L17.1475 4.86226C16.5225 4.38726 15.86 3.98726 15.1225 3.68726L14.6725 
    0.512256C14.6225 0.212256 14.3725 -0.000244141 14.0725 -0.000244141H9.2725C8.9725 -0.000244141 8.735 
    0.212256 8.685 0.512256L8.235 3.68726C7.4975 3.98726 6.8225 4.39976 6.21 4.86226L3.2225 3.66226C2.9475 3.56226 
    2.635 3.66226 2.485 3.93726L0.0975004 8.08726C-0.0524996 8.34976 -0.00249971 8.67476 0.2475 8.84976L2.785 10.8248C2.7225 
    11.1998 2.6725 11.6123 2.6725 11.9998C2.6725 12.3873 2.6975 12.7998 2.76 13.1748L0.2225 15.1498C-0.0024997 15.3248 
    -0.0649995 15.6623 0.0725004 15.9123L2.4725 20.0623C2.6225 20.3373 2.935 20.4248 3.21 20.3373L6.1975 19.1373C6.8225 
    19.6123 7.485 20.0123 8.2225 20.3123L8.6725 23.4873C8.735 23.7873 8.9725 23.9998 9.2725 23.9998H14.0725C14.3725 23.9998 
    14.6225 23.7873 14.66 23.4873L15.11 20.3123C15.8475 20.0123 16.5225 19.6123 17.135 19.1373L20.1225 20.3373C20.3975 20.4373 
    20.71 20.3373 20.86 20.0623L23.26 15.9123C23.41 15.6373 23.3475 15.3248 23.11 15.1498L20.5975 13.1748ZM11.6725 
    16.4998C9.1975 16.4998 7.1725 14.4748 7.1725 11.9998C7.1725 9.52476 9.1975 7.49976 11.6725 7.49976C14.1475 7.49976 
    16.1725 9.52476 16.1725 11.9998C16.1725 14.4748 14.1475 16.4998 11.6725 16.4998Z"
    fill="white"
    fill-opacity="0.75"
  />
</svg>
